module.exports = __webpack_public_path__ + "img/transfer2.0f3f7627.jpeg";